<ion-accordion
  value="{{ state?.facetId }}"
  *ngIf="
    state?.hasActiveValues === false ||
    state?.selectedValueAncestry[state?.selectedValueAncestry.length - 1]
      .children.length > 0
  "
>
  <ion-item slot="header" class="facet-header" lines="none">
    {{ state?.displayName }}
  </ion-item>
  <div slot="content" class="facet-value-list">
    <div class="search-bar-container">
      <app-search-bar-facet
        [controller]="controller"
        (showSearchFacetEmitter)="setShowSearchFacet($event)"
        (searchSelectFacetEmitter)="setCurrentFacetId($event)"
      ></app-search-bar-facet>
    </div>

    <div
      class="facet-value-container"
      *ngIf="!showSearchFacet && state?.facetSearch?.values.length === 0"
    >
      <ng-container *ngIf="state?.values[0]?.children?.length === 0">
        <ion-item
          class="facet-selection-container"
          *ngFor="let category of state?.values; let i = index"
          [class.first]="i === 0"
        >
          <ion-checkbox
            labelPlacement="start"
            justify="space-between"
            class="facet-selection"
            mode="ios"
            [checked]="category.state === 'selected'"
            (ionChange)="handleCheckboxSelection(controller, category)"
          >
            <span class="facet-value-text">
              {{ category.value | acronymTitleCase | truncateWithEllipsis: 40 }}
            </span>
            <ion-badge mode="ios">
              {{ category.numberOfResults }}
            </ion-badge>
          </ion-checkbox>
        </ion-item>
      </ng-container>
      <ng-container
        *ngIf="
          state?.selectedValueAncestry &&
          state?.selectedValueAncestry.length > 0
        "
      >
        <ion-item
          class="facet-selection-container"
          *ngFor="
            let category of state?.selectedValueAncestry[
              state?.selectedValueAncestry.length - 1
            ]?.children;
            let i = index
          "
          [class.first]="i === 0"
        >
          <ion-checkbox
            labelPlacement="start"
            justify="space-between"
            class="facet-selection"
            mode="ios"
            [checked]="category.state === 'selected'"
            (ionChange)="handleCheckboxSelection(controller, category)"
          >
            <span class="facet-value-text">
              {{ category.value | acronymTitleCase | truncateWithEllipsis: 40 }}
            </span>
            <ion-badge mode="ios">
              {{ category.numberOfResults }}
            </ion-badge>
          </ion-checkbox>
        </ion-item>
      </ng-container>
    </div>
  </div>
</ion-accordion>
